import { Image } from "@chakra-ui/react";
import React from "react";
import defaultLogo from "../../assets/logo.png";

const baseUrl = "https://asquera.com/asquera";

const SectionLogo = ({ logo, size = "90px" }) => {
  const hasLogo =
    logo && logo !== "null" && logo !== "undefined" && logo !== "NULL";

  return (
    <Image
      src={hasLogo ? `${baseUrl}/${logo}` : defaultLogo}
      alt="section logo"
      w={size}
      h={size}
      minW={size}
      objectFit="contain"
      borderRadius="4px"
    />
  );
};

export default SectionLogo;
